import React from 'react';

import AdminEnrollmentManagementLoader from './AdminEnrollmentManagementLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import AdminEnrollmentManagementTable from './AdminEnrollmentManagementTable';
import { useAdminEnrollmentManagementState } from './AdminEnrollmentManagementContext';
import styles from './AdminEnrollmentManagement.module.scss';

const AdminEnrollmentManagementContent = () => {
  const state = useAdminEnrollmentManagementState();

  if (state?.loading) {
    return (
      <div className={styles.pageLayout}>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading</p>
      </div>
    );
  }

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        <PageTitle text={'Enrollment Management'} />
        <AdminEnrollmentManagementTable />
      </Stack>
    </div>
  );
};

const AdminEnrollmentManagement = () => {
  return (
    <>
      <AdminEnrollmentManagementLoader />
      <AdminEnrollmentManagementContent />
    </>
  );
};

export default AdminEnrollmentManagement;
